export default function isTooYoung(age: number, minAge: number): boolean {
	return minAge > age;
}
